import { getFullName } from '@zorro/common-utils';
import { Button } from '@zorro/design-system/v2/Button';
import { Drawer } from '@zorro/design-system/v2/Drawer';
import { Title } from '@zorro/design-system/v2/Title';
import { WomanWritingOnTablet } from '@zorro/shared/assets';
import { Center, Flex, Stack } from '@zorro/web/design-system';
import { useAppRouter, useMonolithQuery, useRoles } from '@zorro/web/ui-utils';
import { useState } from 'react';

import {
  AddEnrollmentRecordForm,
  mapEmployeeForActions,
} from '../EmployeeActions';
import { FullPageLoader } from '../FullPageLoader';

type Props = {
  employerId: string;
  employeeId: string;
};

export const NoEnrollments = ({ employerId, employeeId }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const { navigateToRoute } = useAppRouter();
  const { isEmployerAdmin } = useRoles();

  const { data: employee, isLoading } = useMonolithQuery({
    method: 'employeesControllerFindOne',
    params: [employeeId],
  });
  if (isLoading || employee === undefined) {
    return <FullPageLoader />;
  }

  const recordForActions = mapEmployeeForActions(employee);

  return (
    <>
      <Flex
        mt="12rem"
        justify="center"
        align="center"
        direction="column"
        gap="2rem"
      >
        <Stack justify="center" align="center" gap="xl">
          <Center w={150}>
            <WomanWritingOnTablet grow />
          </Center>
          {employee && (
            <Title order={2}>
              {getFullName(employee)} doesn't have any enrollments yet
            </Title>
          )}
        </Stack>
        {!isEmployerAdmin && (
          <Button size="md" onClick={() => setIsModalOpen(true)}>
            Add a new enrollment
          </Button>
        )}
      </Flex>

      {!isEmployerAdmin && employee && (
        <Drawer
          opened={isModalOpen}
          title="Add enrollment record"
          onClose={() => setIsModalOpen(false)}
        >
          <AddEnrollmentRecordForm
            employerId={employerId}
            onSuccess={(onboardingPeriodId) => {
              setIsModalOpen(false);
              // eslint-disable-next-line @typescript-eslint/no-unused-expressions
              onboardingPeriodId
                ? navigateToRoute('OPS_EMPLOYEE_PLANS_TAB', [
                    {
                      employerId,
                      employeeId,
                      onboardingPeriodId,
                    },
                  ])
                : navigateToRoute('OPS_EMPLOYEE_PAGE', [
                    { employerId, employeeId },
                  ]);
            }}
            recordsForActions={[recordForActions]}
          />
        </Drawer>
      )}
    </>
  );
};
